import { DataProductApi } from '../constants/api';
import { REGION_TO_AIRPORT_CODE } from '../constants/regionAirportCodes';
import { useAppSettings } from '../context/AppSettings';

const constructApiEndpoint =
  (region: string, stage: string) =>
  (prefix: string, apiName: string): string => {
    const airport = REGION_TO_AIRPORT_CODE[region];
    return `https://${prefix}.${airport}.${stage}.${apiName}.groundstation.aws.dev/graphql`;
  };

export type DataProductEndpoints = Record<DataProductApi, string>;

export const useDataProductEndpoints = (): DataProductEndpoints => {
  const { graphqlApiUrl, region, stage } = useAppSettings();
  const endpointCreator = constructApiEndpoint(region, stage);

  return {
    [DataProductApi.DATA_PLANE_API]: endpointCreator('api', 'agent-dp'),
    [DataProductApi.CONTROL_PLANE_DATA_PRODUCT_API]: endpointCreator('api', 'controlplane-dp'),
    [DataProductApi.ANTENNA_DATA_PRODUCT_API]: endpointCreator('api', 'antenna-dp'),
    [DataProductApi.CURATED_API]: graphqlApiUrl,
  };
};
